import { render, staticRenderFns } from "./terms-conditions.vue?vue&type=template&id=39346988&scoped=true&"
import script from "./terms-conditions.vue?vue&type=script&lang=ts&"
export * from "./terms-conditions.vue?vue&type=script&lang=ts&"
import style0 from "./terms-conditions.vue?vue&type=style&index=0&id=39346988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39346988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
